export const escapeRegExp = (regexp: string): string => {
    return regexp.replace(/[-[\]\/{}()*+?.\\^$|]/g, '\\$&')
}

export function escapeRegExpString(str: string): string {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
}
